import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { SearchItemService } from '@coin/shared/core/util-models';
import { IncentiveSupportComponentState } from './incentive-support.component.state';
import { IncentivePartnerService } from '@coin/shared/core/data-access-v2';
import { MonitoringRecord } from '@coin/shared/core/util-models-v2';

@Injectable()
export class MonitoringSearchService implements SearchItemService {
  private readonly incentiveSupportComponentState = inject(IncentiveSupportComponentState);
  private readonly incentiveMonitoringService = inject(IncentivePartnerService);

  getSearchItemsByText(text: string, page: number): Observable<MonitoringRecord[]> {
    const selectedSeason = this.incentiveSupportComponentState.getSelectedSeason();
    if (!selectedSeason) {
      throw new Error('Cannot load records without selected season');
    }
    return this.incentiveMonitoringService
      .queryMonitoring({
        seasonId: selectedSeason.id,
        pagingPage: page + 1,
        pagingSize: 50,
        queryGid: [text]
      })
      .pipe(
        map(result => result.content),
        // Return empty list in case of an error to prevent an error in the view
        catchError(() => of([]))
      );
  }
}
